import styles from './style.module.scss';
import { ActionModal, Button, PageHeader } from 'components';
import { Col, Table, Row, Divider, Alert, Empty } from 'antd';
import { ExcelIcon } from 'icons';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';
import useVacancyApplications from '../useVacancyApplications';
import { Route, Routes } from 'react-router-dom';
import DeleteModal from '../../../../../components/deleteModalView';
import UIHelper from '../../../../../helpers/UIHelper';

const MainPage = () => {
  const {
    data,
    columns,
    filters,
    loading,
    handleDownloadExcel,
    updateInProcess,
    onChangeTableFilter,
    pathname,
    navigate,
    searchParams,
  } = useVacancyApplications();
  const { t } = useTranslation();

  const by_shopping_center = searchParams.get('by_shopping_center');

  return (
    <>
      <PageHeader title={t('CANDIDATURE ANNUNCI')}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              loading={updateInProcess}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <br />
        {!by_shopping_center && (
          <Row>
            <Col span={12}>
              <Alert
                message='Outlet Village non può essere lasciato in bianco'
                type='warning'
              />
            </Col>
          </Row>
        )}
        <Divider />
        {by_shopping_center && (
          <Table
            locale={{
              emptyText: <Empty />,
            }}
            columns={columns}
            dataSource={data.vacancy_applications}
            onChange={onChangeTableFilter}
            loading={loading}
            pagination={data.pagination}
            scroll={{ x: 3000 }}
            // bordered
          />
        )}
      </div>
      <Routes>
        <Route
          path={':id/view'}
          element={
            <ActionModal
              loading={loading}
              title={t(
                'Cliccando su continua verra’ salvato il log dell’operazione',
              )}
              type={'view'}
              description={''}
              yesBtnText={t('Continua')}
              noBtnText={t('Annulla')}
              onClickOk={() => navigate(UIHelper.getListRoute(pathname, 1))}
              onCancel={() => navigate(UIHelper.getListRoute(pathname, 2))}
            />
          }
        />
      </Routes>
    </>
  );
};

export default MainPage;
